import type { ProfitabilitySummaryShippingCostRow } from '../models/Profitability';

export function formatSummaryShippingServiceLabel(
  row: Pick<ProfitabilitySummaryShippingCostRow, 'courier' | 'courier_service'>,
  noServiceLabel: string,
): string {
  const courierName = row.courier?.name?.trim();
  const service = row.courier_service;
  if (!service) return courierName ? `${courierName} — ${noServiceLabel}` : noServiceLabel;

  const code = service.code?.trim();
  const description = service.description?.trim();
  const servicePart = code && description ? `${code} — ${description}` : code || description || `#${service.id}`;

  if (courierName) return `${courierName} — ${servicePart}`;
  return servicePart;
}
